// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"SUw9n980hyrNy64iX-UjZA==","fullImage":"o8BaF5PW3Dm45oQaD-n05g==","reactPlayer":"gQZMTJ1hu7J26pveHgHrNg=="};